import React from 'react';
import PropTypes from 'prop-types';

import MaterialList from '../MaterialList';
import Material from '../Material.container';
import { List, Container, MaterialContent } from './MaterialsTab.styled';

// TODO: Move loader to common
import { SectionsLoader } from '../../../Navigation/SpaceBar/Loaders';

const MaterialTab = (props) => {
  const { shouldDisplaySectionsLoader, route } = props;

  if (shouldDisplaySectionsLoader) {
    return <SectionsLoader />;
  }

  return (
    <Container>
      <List>
        <MaterialList />
      </List>
      <MaterialContent>
        <Material route={route} />
      </MaterialContent>
    </Container>
  );
};

MaterialTab.propTypes = {
  shouldDisplaySectionsLoader: PropTypes.bool.isRequired,
  route: PropTypes.shape({
    childRoutes: PropTypes.array,
    path: PropTypes.string,
  }).isRequired,
};

MaterialTab.default = {
  shouldDisplaySectionsLoader: true,
};

export default MaterialTab;
